import { useEffect, useRef, useState } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useNavigate
} from "react-router-dom";
import MTable from '../../Components/MTable/MTable';
import Swal from 'sweetalert2';
import Overlay from '../../Components/Overlay';
import moment from 'moment';
import Select from "react-select";
import { getUserBranch } from '../../Service/UserService';
import { getWithdrawalList, getWithdrawalListDetail } from '../../Service/WithdrawService';
import WithdrawalListDetail from './WithdrawalListDetail';
import WithdrawalForm from './WithdrawalForm';
import { set } from 'lodash';
import Modal from '../../Components/Layout/Modal';
import { NumberFormat } from "../../Components/NumberFormat";
import MInput from "../../Components/Core/MInput";
import { useSelector } from "react-redux";
const { $ } = window;

const Withdrawal = () => {
    let { userInfo } = useSelector((state) => state.auth);

    let transactionType = [
        {label : 'Customer Payment', value : 'PAYMENT'},
        {label : 'Withdrawal', value : 'DISBURSEMENT'},
        /*{label : 'Remittance Payout', value : 'REMITTANCE_PAYOUT'},
        {label : 'Transfer Transaction', value : 'TRANSFER'},
        {label : 'Refund', value : 'REFUND'},*/
    ];
    let transactionStatus = [
        {label : 'Success', value : 'SUCCESS'},
        {label : 'Pending', value : 'PENDING'},
        {label : 'Failed', value : 'FAILED'},
        /*{label : 'Voided', value : 'VOIDED'},
        {label : 'Reversed', value : 'REVERSED'}*/
    ]
    const [state, setState] = useState({ 
        processing: false, 
        listMHC: [], 
        selectedListMHC: userInfo.role_name === 'Sales Consultant' ? userInfo.BPLName : '',
        transactionType: transactionType,
        selectedtransactionType: transactionType[0].value ,
        transactionStatus: transactionStatus,
        selectedTransactionStatus: transactionStatus[0].value,
        withdrawalList: [],
        balance: {},
        withdrawalSelectedId : '',
        withdrawalListDetail : {},
        withdrawalDate : ""
    });

    const fetchListMHC = async () => {
        try {
            const { data } = await getUserBranch({activate_paging: "0"});
            if(userInfo.role_name === 'Sales Consultant') {
                data.data = data.data.filter(item => item.BPLName === userInfo.BPLName);
            }
            let _listMHC = data?.data?.map(item => ({ label: item.BPLName +' : '+ item.BPLFrName, value: item.BPLName })).filter(opt => opt.value.toLowerCase() !== 'main');
            if(userInfo.role_name !== 'Sales Consultant') {
                _listMHC.unshift({ label: 'All Store', value: '' });
            }else{
                setState((prev) => {
                    return { ...prev, selectedListMHC: _listMHC[0].value };
                });
            }
            setState((prev) => {
                return { ...prev, listMHC: _listMHC };
            });
        } catch (err) {
            console.log(err);
        }

    }

    const fetchWithdrawalSummary = async () => {
        try {
            let payload = {
                types: state.selectedtransactionType,
                statuses: state.selectedTransactionStatus,
                store: state.selectedListMHC
            }
            const { data } = await getWithdrawalList(payload);
            setState((prev) => {
                return { ...prev, balance: data.summary };
            });
        } catch (err) {
            console.log(err);
        }
    }

    const fetchWithdrawalList = () => {
        let payload = {
            types: state.selectedtransactionType,
            statuses: state.selectedTransactionStatus,
            store: state.selectedListMHC,
            withdraw_date: state.withdrawalDate
        }
        return getWithdrawalList(payload);
    }

    const setStateWithdrawalSelectedId = (id) => {
        return () => {
            setState({ ...state, withdrawalSelectedId: id });
        }
    }

    const setStateWithdrawalList = (data) => {
        setState((prev) => {
            return { ...prev, withdrawalList: data };
        });
    }

    const showWithdrawalForm = () => {
        $('#modalWithdrawalForm').modal('show');
    }

    const fetchWithdrawalListDetail = async () => {
        try {
            const { data } = await getWithdrawalListDetail(state.withdrawalSelectedId);
            setState((prev) => {
                return { ...prev, withdrawalListDetail: data, withdrawalSelectedId: ''};
            });
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        fetchListMHC();
    }, []);
    useEffect(() => {
        fetchWithdrawalSummary();
        withdrawTableRef.current.refresh();
    }, [state.selectedListMHC, state.selectedtransactionType, state.selectedTransactionStatus]);
    useEffect(() => {
        if (state.withdrawalSelectedId !== '') {
            fetchWithdrawalListDetail();
            $('#modalWithdrawalListDetail').modal('show');
        }
    }, [state.withdrawalSelectedId]);

    let columnPayment = [
        { id:1, title: 'Transaction ID', field: 'reference_id' },
        { id:2, title: 'Transaction Type', field: 'type' },
        { id:3, title: 'Transaction Status', field: 'status' },
        { id:4, title: 'Transaction Date', field: 'estimated_settlement_time', render: (row) => { return moment(row.estimated_settlement_time).format('DD MMMM YYYY HH:mm:ss'); }},
        { id:5, title: 'Amount', field: 'amount', render: (row) => { return NumberFormat(row.amount);}},
        { id:6, title: 'Net Amount', field: 'net_amount' , render: (row) => { return NumberFormat(row.net_amount);}},
        { id:7, title: 'Action', field: 'action', render : (row) => { return <div><button className='btn btn-modena' onClick={setStateWithdrawalSelectedId(row.reference_id)} style={{fontWeight: 'lighter'}}>View Detail</button></div> }},
    ]
    let columnWithdrawal = [
        { id:1, title: 'Transaction ID', field: 'reference_id' },
        { id:2, title: 'Withdrawal Number', field: 'withdraw_number' },
        { id:3, title: 'Transaction Type', field: 'type' },
        { id:4, title: 'Transaction Status', field: 'status' },
        { id:5, title: 'Transaction Date', field: 'estimated_settlement_time', render: (row) => { return moment(row.estimated_settlement_time).format('DD MMMM YYYY HH:mm:ss'); }},
        { id:6, title: 'Amount', field: 'amount', render: (row) => { return NumberFormat(row.amount);}},
        { id:7, title: 'Net Amount', field: 'net_amount' , render: (row) => { return NumberFormat(row.net_amount);}},
        { id:8, title: 'Action', field: 'action', render : (row) => { return <div><button className='btn btn-modena' onClick={setStateWithdrawalSelectedId(row.reference_id)} style={{fontWeight: 'lighter'}}>View Detail</button></div> }},
    ]

    const withdrawTable = { 
        columns: state.selectedtransactionType === 'PAYMENT' ? columnPayment : columnWithdrawal, 
        getData: fetchWithdrawalList, 
        showIndex: true,
        //perpage : 10,
        showPaginationCounter: false,
        onRefresh: setStateWithdrawalList,
        useSearch: false,
        useFilter: false,
    };

    const withdrawTableRef = useRef();

    return (
        <div className="content-wrapper" >
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">Payment Gateway Withdrawal</h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className='table-responsive' style={{ minHeight:'500px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', backgroundColor:'#EEE', padding: '17px' }}>
                                {/* <label style={{ marginRight: '15px' }}>Select Store</label> */}
                                <Select
                                    options={state.listMHC}
                                    value={state.listMHC.find(option => option.value === state.selectedListMHC)}
                                    onChange={(selectedOption) => setState((prev) => ({ ...prev, selectedListMHC: selectedOption.value }))}
                                    placeholder="Select Store"
                                    styles={{
                                        control: (styles) => ({
                                            ...styles,
                                            minWidth: '300px',
                                        }),
                                    }}
                                /> 
                                {/* <label style={{ marginRight: '15px', marginLeft:'15px' }}>Transaction</label> */}
                                <Select
                                    options={state.transactionType}
                                    placeholder="Select Transaction Type"
                                    styles={{
                                        control: (styles) => ({
                                            ...styles,
                                            width: '300px',
                                            marginLeft: '17px',
                                        }),
                                    }}
                                    value={state.transactionType.find(option => option.value === state.selectedtransactionType)}
                                    onChange={(selectedOption) => setState((prev) => ({ ...prev, selectedtransactionType: selectedOption.value }))}
                                />
                                {/* <label style={{ marginRight: '15px', marginLeft:'15px' }}>Status</label> */}
                                <Select
                                    options={state.transactionStatus}
                                    placeholder="Select Status"
                                    styles={{
                                        control: (styles) => ({
                                            ...styles,
                                            width: '300px',
                                            marginLeft: '17px',
                                        }),
                                    }}
                                    value={state.transactionStatus.find(option => option.value === state.selectedTransactionStatus)}
                                    onChange={(selectedOption) => setState((prev) => ({ ...prev, selectedTransactionStatus: selectedOption.value }))}
                                />
                                {
                                    state.selectedtransactionType === 'DISBURSEMENT' &&
                                    <MInput
                                        type="date"
                                        value={state.withdrawalDate}
                                        onChange={(e) => {
                                            setState((prev) => ({ ...prev, withdrawalDate: e.target.value }));
                                            withdrawTableRef.current.refresh();
                                        }}
                                        placeholder="Withdrawal Date"
                                        style={{ width: "300px", marginLeft: '17px', }}
                                    />
                                }
                            </div>
                            {
                                state.selectedtransactionType === "DISBURSEMENT" &&
                                <div style={{marginLeft:"13px"}}>
                                    *. If withdrawal date is not defined, it will show today withdrawal list
                                </div>
                            }
                            <div style={{ display: 'flex', alignItems: 'center', padding: '17px' }}>
                                <h4 style={{display: 'inline-flex'}}>Summary of Amount (IDR) : {NumberFormat(state.balance.amount)}</h4>
                                <h4 style={{display: 'inline-flex', marginLeft: '17px'}}>| Net Amount (IDR) : {NumberFormat(state.balance.net_amount)}</h4>
                                {
                                userInfo.role_name === 'Accounting Staff' && state.selectedtransactionType === 'PAYMENT' && state.selectedTransactionStatus === 'SUCCESS' && state.selectedListMHC !== '' && state.withdrawalList.length > 0 &&
                                <div style={{display: 'inline-flex', marginLeft: '17px'}}><button className='btn btn-primary btn-block' onClick={showWithdrawalForm}>Withdraw</button></div>
                                }
                            </div>
                            <div style={{padding:'17px 11px 17px 11px', overflow: 'hidden'}}>
                            { 
                                <MTable
                                {...withdrawTable} ref={withdrawTableRef}
                                /> 
                            }
                            </div>
                            <div>
                                <Modal id="modalWithdrawalListDetail" modalStyle={{maxWidth:'700px'}}>
                                    <WithdrawalListDetail {...state} />
                                </Modal>                          
                            </div>
                            <div>
                                <Modal id="modalWithdrawalForm"  modalStyle={{maxWidth:'700px'}}>
                                    <WithdrawalForm {...state} 
                                        onChangeTable={()=>withdrawTableRef.current.refresh()}  
                                        onChangeSummary={()=>fetchWithdrawalSummary()}
                                         />
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Withdrawal;